import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// Redux
import { connect } from 'react-redux';
import { loginUser } from '../redux/actions/userActions';

import AppIcon from '../images/icon.png';
import formStyle from '../utils/formStyles';
import withRouter from '../utils/withRouter';

// MUI stuff
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

class Login extends Component {

    constructor() {
        super();
        this.state = {
            email: '',
            password: '',
            errors: {}
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.UI.errors) {
            this.setState({ errors: nextProps.UI.errors })
        }
    }

    handleSubmit = event => {
        event.preventDefault();
        const userData = {
            email: this.state.email,
            password: this.state.password
        };
        this.props.loginUser(userData, this.props.navigate);
    }

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    }

    render() {
        const { classes, UI: { loading } } = this.props;
        const { errors } = this.state;
        return (
            <Grid container justifyContent="center" style={{ marginTop: 40 }}>
                <Grid item xs={11} sm={7} md={5} lg={4}>
                    <Paper className={classes.formPaper} elevation={3}>
                        <img src={AppIcon} alt="monkey" className={classes.image} />
                        <Typography variant="h4" align="center" className={classes.pageTitle}>Social Ape</Typography>
                        <Typography variant="h5" align="center" gutterBottom>Login</Typography>
                        <form noValidate onSubmit={this.handleSubmit}>
                            <Stack spacing={2.5} sx={{ mt: 2 }}>
                                <TextField
                                    id="email"
                                    name="email"
                                    type="email"
                                    label="Email"
                                    helperText={errors.email}
                                    error={errors.email ? true : false}
                                    value={this.state.email}
                                    onChange={this.handleChange}
                                    fullWidth
                                />
                                <TextField
                                    id="password"
                                    name="password"
                                    type="password"
                                    label="Password"
                                    helperText={errors.password}
                                    error={errors.password ? true : false}
                                    value={this.state.password}
                                    onChange={this.handleChange}
                                    fullWidth
                                />
                                {errors.general && (
                                    <Typography variant="body2" className={classes.customError}>
                                        {errors.general}
                                    </Typography>
                                )}
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    fullWidth
                                    disabled={loading}>
                                    Login
                                    {loading && <CircularProgress size={22} className={classes.progress} />}
                                </Button>
                            </Stack>
                            <Typography variant="body2" align="center" style={{ marginTop: 20 }}>
                                Don't have an account?{' '}
                                <Link to="/signup">Sign up here</Link>
                            </Typography>
                        </form>
                    </Paper>
                </Grid>
            </Grid>
        )
    }
}

Login.propTypes = {
    classes: PropTypes.object.isRequired,
    loginUser: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    UI: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
    user: state.user,
    UI: state.UI
});

export default connect(mapStateToProps, { loginUser })(withStyles(formStyle)(withRouter(Login)));
